import type { SxProps, Theme } from '@mui/material/styles';

export const styles = {
    layout: {
        p: 1,
    },
    img: {
        width: '100%',
        height: '100%',
    },
} satisfies Record<string, SxProps<Theme>>;
